import Vue from 'vue'
import Vuex from 'vuex'
import axios from './axios-auth'
import router from '../router/index.js'
import createPersistedState from "vuex-persistedstate";
import { trackingMutations, trackingActions, trackingGetters } from '@/utils/tracking';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // Existing state
    accessToken: null,
    userData: [],
    progressItems: [],
    lastCheckedProgress: null,
    loggingIn: false,
    transactionItems: [],
    appointments: null,
    lab: null,
    priscription: null,
    shipping: null,
    tracking: null,
    ipAddress: null,
    medForm: null,
    prescriptionPreauths: null,
    lastCheckedSubscription: null,
    subscriptionItems:[],
    lastCheckedTransactions: null,
    trackingData: [], 
    // Cart state
    cartItems: [],
    isCartOpen: false,
    weightLossOffer: null,
    // New product-related state
    currentCategory: 'WEIGHT LOSS',
    loading: false,
    error: null,
    offerSema: 'sema_plan_278928',
    offerTir: 'tirz_plan_1'
  },
  
  mutations: {
    ...trackingMutations,
    SET_SEMA_OFFER(state, offer) {
      state.offerSema = offer==='A' ? 'sema_plan_134562' : offer==='B' ? 'sema_plan_278928' : 'sema_plan_367367';
    },
    SET_TIR_OFFER(state, offer) {
      state.offerTir = offer==='A' ? 'tirz_plan_1' : offer==='B' ? 'tirz_plan_2' : 'tirz_plan_3';
    },
    SET_Transactions_ITEMS(state, payload) {
      
      if (payload && payload.items) {
        state.transactionItems = payload.items;
        state.lastCheckedTransactions = payload.timestamp;
      }
    },
    SET_SUBSCRIPTION_ITEMS(state, payload) {
      
      if (payload && payload.items) {
        state.subscriptionItems = payload.items;
        state.lastCheckedSubscription = payload.timestamp;
      }
    },
    SET_PROGRESS_ITEMS(state, payload) {
      
      if (payload && payload.items) {
        state.progressItems = payload.items;
        state.lastCheckedProgress = payload.timestamp;
      }
    },
    SET_PRESCRIPTION_PREAUTHS(state, preauths) {
      state.priscription = preauths;
    },
    REMOVE_PRESCRIPTION(state, orderId) {
      state.priscription = state.priscription.filter(
        preauth => preauth.orderId !== orderId
      );
    },
    // Existing mutations remain the same
    loginStart: state => state.loggingIn = true,
    updateAccessToken: (state, accessToken) => {
      state.accessToken = accessToken;
    },
    updateUserData: (state, userData) => {
      state.userData = { ...state.userData, ...userData }
    },
    logout: (state) => {
      state.accessToken = null;
      localStorage.removeItem('accessToken');
      localStorage.removeItem('user');
    },
    
    SaveShippingDetails: (state, shipping) => {
      state.shipping = shipping
    },
    setIpAddress(state, ipAddress) {
      state.ipAddress = ipAddress;
    },

    // Cart mutations
    ADD_TO_CART(state, item) {
      console.log('Cart item being added to cart in store:', item); // Debug log
      const existingItem = state.cartItems.find(i => i.id === item.id);
      
      // Create the new item with all properties explicitly
      const newItem = {
          id: item.id,
          name: item.name,
          price: item.price,
          retail_price: item.retail_price,
          quantity: item.quantity,
          main_type: item.main_type,
          subheader: item.subheader,
          image: item.image,
          category: item.category,
          sku: item.sku,
          stripe_id: item.stripe_id
      };
      console.log(newItem)
      if (existingItem) {
        existingItem.quantity += 1;
      } else {
          state.cartItems.push(newItem);
      }
      /*if (item.main_type === "prescription") {
          if (!existingItem) {
              state.cartItems.push(newItem);
          }
      } else {
          if (existingItem) {
              existingItem.quantity += 1;
          } else {
              state.cartItems.push(newItem);
          }
      }*/
  },
    
    REMOVE_FROM_CART(state, itemId) {
      state.cartItems = state.cartItems.filter(item => item.id !== itemId);
    },
    
    UPDATE_CART_QUANTITY(state, { itemId, quantity }) {
      const item = state.cartItems.find(i => i.id === itemId);
      if (item) {
        if (item.main_type === "Prescription") {
          item.quantity = 1;
        } else {
          if (quantity > 0) {
            item.quantity = quantity;
          } else {
            state.cartItems = state.cartItems.filter(i => i.id !== itemId);
          }
        }
      }
    },
    
    CLEAR_CART(state) {
      state.cartItems = [];
    },
    
    SET_CART_VISIBILITY(state, isVisible) {
      state.isCartOpen = isVisible;
    },

    // New product-related mutations
    SET_CURRENT_CATEGORY(state, category) {
      state.currentCategory = category;
    },
    
    SET_LOADING(state, status) {
      state.loading = status;
    },
    
    SET_ERROR(state, error) {
      state.error = error;
    }
  },

  actions: {
    ...trackingActions,
    addSemaOffer({ commit }, offer) {
      commit('SET_SEMA_OFFER', offer);
    },
    addTirOffer({ commit }, offer) {
      commit('SET_TIR_OFFER', offer);
    },
    updateTransactionItems({ commit }, payload) {
      commit('SET_Transactions_ITEMS', payload);
    },
    updateSubscriptions({ commit }, payload) {
      commit('SET_SUBSCRIPTION_ITEMS', payload);
    },
    updateProgress({ commit }, payload) {
      commit('SET_PROGRESS_ITEMS', payload);
    },
    setPrescriptionPreauths({ commit }, preauths) {
      commit('SET_PRESCRIPTION_PREAUTHS', preauths);
    },
    UpdateUserData({ commit }, userData) {
      commit('updateUserData', userData)
      return Promise.resolve() // Return a promise for proper async handling
    },
    removePrescription({ commit }, orderId) {
      commit('REMOVE_PRESCRIPTION', orderId);
    },
    // Existing actions remain the same
    saveTransaction({ commit }, data) {
      commit('SaveTransactions', data);
    },
    saveShippingDetails({ commit }, data) {
      commit('SaveShippingDetails', data);
    },
    doLogin({ commit }, loginData) {
      commit('updateAccessToken', loginData.token.token);
      commit('updateUserData', loginData.user);
    },
    
    logout({ commit }, data) {
      return new Promise((resolve, reject) => {
        let token = data.token;
        axios.get("/logout", {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          }
        }).then(res => {
          commit('updateAccessToken', null);
          console.log(res);
          localStorage.removeItem('_ymain_key_');
          router.push({ name: 'LoginPage' });
        }).catch(error => {
          reject(error)
        });
      });
    },

    async getIpAddress({ commit }) {
      try {
        const response = await axios.get('https://cors-anywhere.herokuapp.com/http://api.ipify.org/?format=text');
        commit('setIpAddress', response.data);
      } catch (error) {
        console.error('Error fetching IP address:', error);
      }
    },

    // Cart actions
    addToCart({ commit }, item) {
      
      commit('ADD_TO_CART', item);
      commit('SET_CART_VISIBILITY', true);
    },
    
    removeFromCart({ commit }, itemId) {
      commit('REMOVE_FROM_CART', itemId);
    },
    
    updateCartQuantity({ commit }, { itemId, quantity }) {
      commit('UPDATE_CART_QUANTITY', { itemId, quantity });
    },
    
    clearCart({ commit }) {
      commit('CLEAR_CART');
    },
    
    setCartVisibility({ commit }, isVisible) {
      commit('SET_CART_VISIBILITY', isVisible);
    },

    // New product-related actions
    setCategory({ commit }, category) {
      commit('SET_CURRENT_CATEGORY', category);
    },
    
    setLoading({ commit }, status) {
      commit('SET_LOADING', status);
    },
    
    setError({ commit }, error) {
      commit('SET_ERROR', error);
    }
  },

  getters: {
    ...trackingGetters,
    offerSema: state => state.offerSema,
    offerTir: state => state.offerTir,
    lastCheckedProgress: state => state.lastCheckedProgress,
    progressItems: state => state.progressItems,
    user: state => state.userData,
    isAuthenticated: state => state.accessToken !== null,
    isAdmin: state => state.userData?.is_admin === 1,
    authToken: state => state.accessToken,
    transactionItems: state => state.transactionItems,
    lastCheckedTransactions: state => state.lastCheckedTransactions,
    subscription: state => state.subscription,
    appointment: state => state.appointments,
    prescription: state => state.priscription,
    tracking: state => state.tracking,
    lab: state => state.lab,
    shipping: state => state.shipping,
    medForm: state => state.medForm,
    ipAddress: state => state.ipAddress,

    // Cart getters
    cartItems: state => state.cartItems,
    cartItemCount: state => state.cartItems.reduce((total, item) => total + item.quantity, 0),
    cartTotal: state => {
      return state.cartItems.reduce((total, item) => {
        const price = parseFloat(item.price.toString());
        return total + (price * item.quantity);
      }, 0);
    },
    cartTotalNoDiscount: state => {
      return state.cartItems.reduce((total, item) => {
        const price = parseFloat(item.retail_price.toString());
        return total + (price * item.quantity);
      }, 0);
    },

    cartDiscount: state => {
      console.log(JSON.stringify(state.cartItems))
      return state.cartItems.reduce((total, item) => {
        const retailPrice = parseFloat(item.retail_price.toString().replace('$', ''));
        const currentPrice = parseFloat(item.price.toString().replace('$', ''));
        return total + ((retailPrice - currentPrice) * item.quantity);
      }, 0);
    },
    isCartOpen: state => state.isCartOpen,
    getRemainingPrescriptions: state => state.priscription,
    // New product-related getters
    currentCategory: state => state.currentCategory,
    loading: state => state.loading,
    error: state => state.error,
    lastCheckedSubscription: state => state.lastCheckedSubscription,
    subscriptionItems: state => state.subscriptionItems,
  },

  plugins: [
    createPersistedState({
      key: '_ymain_key_',
      paths: [
        'accessToken', 
        'userData', 
        'transaction', 
        'subscription', 
        'appointments', 
        'lab', 
        'priscription', 
        'shipping', 
        'tracking',
        'ipAddress',
        'medForm',
        'cartItems',
        'isCartOpen',
        'currentCategory',
        'progressItems', 
        'lastCheckedProgress',
        'subscriptionItems',
        'lastCheckedSubscription',
        'transactionItems',
        'lastCheckedTransactions',
        'offerTir',
        'offerSema',
        'trackingData'
      ]
    })
  ],
})
